export default __webpack_public_path__ + "static/clothing-v2-04-top-chest-95dd98a2d5805b9290a2e9876326f669.png";